"use client"

import { useEffect } from "react"
import { AlertTriangle, RefreshCw } from "lucide-react"
import { captureException } from "@/lib/telemetry-client"

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    console.error("[global-error]", error)
    captureException(error, { boundary: "app/global-error.tsx", digest: error.digest })
  }, [error])

  return (
    <html lang="en">
      <body className="min-h-screen flex items-center justify-center p-6 bg-slate-50">
        <div className="max-w-md w-full border border-red-200 bg-red-50/50 rounded-xl p-6 space-y-4">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-red-100 rounded-full">
              <AlertTriangle className="h-6 w-6 text-red-600" />
            </div>
            <div>
              <h1 className="text-lg font-semibold text-red-900">Critical Error</h1>
              <p className="text-sm text-red-700">
                The application encountered a critical error
              </p>
            </div>
          </div>
          <div className="bg-red-100 p-3 rounded-lg">
            <p className="text-sm font-mono text-red-800 break-words">
              {error.message || "Unknown error"}
            </p>
          </div>
          <button
            onClick={reset}
            className="w-full flex items-center justify-center gap-2 px-4 py-2 bg-white border border-slate-200 rounded-lg hover:bg-slate-50 transition-colors"
          >
            <RefreshCw className="h-4 w-4" />
            Try Again
          </button>
        </div>
      </body>
    </html>
  )
}
